import { InputHTMLAttributes, forwardRef, ReactNode } from 'react';
import clsx from 'clsx';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  leftIcon?: ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, leftIcon, ...rest }, ref) => (
    <div className="w-full">
      <div className="relative">
        {leftIcon && (
          <span className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-white/40">
            {leftIcon}
          </span>
        )}
        <input
          ref={ref}
          className={clsx(
            'w-full rounded-2xl py-4 text-[15px] text-white outline-none',
            'bg-white/[0.06] border placeholder:text-white/35',
            'transition-all duration-150',
            'focus:bg-white/[0.09] focus:ring-2 focus:ring-primary/20',
            leftIcon ? 'pl-12 pr-5' : 'px-5',
            error
              ? 'border-danger/70 focus:border-danger/70'
              : 'border-white/[0.12] focus:border-primary/70',
            className,
          )}
          {...rest}
        />
      </div>
      {error && <p className="mt-1.5 text-xs text-danger px-1">{error}</p>}
    </div>
  ),
);

Input.displayName = 'Input';
